// خروجیِ جدول → CSV (بازشو در Excel با UTF-8 BOM و ارقامِ درست) و کپیِ کلیپ‌بورد.
// از خودِ ستون‌های GxTable (title + dataIndex + render) استفاده می‌کند تا خروجی
// دقیقاً همانی باشد که کاربر می‌بیند: فقط ستون‌های مرئی، به ترتیبِ فعلی، دادهٔ فیلترشده.

// متنِ خام از سلول: اگر ستون render دارد و رشته/عدد برمی‌گرداند از آن، وگرنه مقدارِ خام.
function cellText(col, record, index) {
  const di = col.dataIndex;
  let raw = di == null ? undefined
    : Array.isArray(di) ? di.reduce((o, k) => (o == null ? o : o[k]), record) : record?.[di];
  if (typeof col.exportValue === "function") return col.exportValue(raw, record, index);
  if (typeof col.render === "function") {
    try {
      const out = col.render(raw, record, index);
      if (out == null) return "";
      if (typeof out === "string" || typeof out === "number") return String(out);
      // اگر render المانِ React داد، به مقدارِ خام برگرد (متنِ تمیزتر برای گزارش)
      if (raw != null && (typeof raw === "string" || typeof raw === "number")) return String(raw);
      return "";
    } catch {
      return raw == null ? "" : String(raw);
    }
  }
  return raw == null ? "" : String(raw);
}

// فقط ستون‌های واقعی (بدونِ ستونِ اکشن/انتخاب) که مرئی‌اند
function exportableCols(columns) {
  return (columns || []).filter(
    (c) => c && c.dataIndex != null && c.gxExport !== false && c.__hidden !== true
  );
}

/**
 * ستون‌ها + ردیف‌ها به شکلی که اندپوینتِ اکسل می‌خواهد.
 *
 * دقیقاً همان ستون‌های **مرئی**، به همان ترتیب، و همان دادهٔ **فیلترشده**.
 * ستونی که محتوایش شبا/کارت/کد است `text` می‌گیرد تا اکسل صفرِ ابتدایی را
 * نخورد — یک شماره کارتِ خراب یعنی پول به حسابِ اشتباه.
 */
const TEXTY_HINT = /شبا|کارت|حساب|کد|شناسه|شماره|iban|card|code/i;

export function tableToPayload(columns, data, title) {
  const cols = exportableCols(columns);
  const columnsOut = cols.map((c, i) => {
    const key = String(c.key ?? c.dataIndex ?? `c${i}`);
    const titleTxt = typeof c.title === "string" ? c.title : String(c.dataIndex ?? key);
    return {
      key,
      title: titleTxt,
      align: c.align === "center" || c.align === "left" ? c.align : undefined,
      text: TEXTY_HINT.test(`${key} ${titleTxt}`),
    };
  });
  const rows = (data || []).map((rec, i) => {
    const o = {};
    cols.forEach((c, ci) => {
      const key = columnsOut[ci].key;
      const di = c.dataIndex;
      const raw = di == null ? undefined
        : Array.isArray(di) ? di.reduce((a, k) => (a == null ? a : a[k]), rec) : rec?.[di];
      // عدد را عدد نگه می‌داریم تا در اکسل قابلِ جمع باشد؛ بقیه متنِ نمایشی
      if (typeof raw === "number" && !columnsOut[ci].text) o[key] = raw;
      else o[key] = cellText(c, rec, i);
    });
    return o;
  });
  return { title: title || "خروجی", columns: columnsOut, rows };
}

export function tableToMatrix(columns, data) {
  const cols = exportableCols(columns);
  const header = cols.map((c) => (typeof c.title === "string" ? c.title : String(c.dataIndex)));
  const body = (data || []).map((rec, i) => cols.map((c) => cellText(c, rec, i)));
  return { header, body };
}

function csvEscape(s) {
  const v = String(s ?? "");
  return /[",\n\r]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v;
}

export function exportCsv(columns, data, filename = "export.csv") {
  const { header, body } = tableToMatrix(columns, data);
  const lines = [header, ...body].map((row) => row.map(csvEscape).join(",")).join("\r\n");
  const blob = new Blob(["﻿" + lines], { type: "text/csv;charset=utf-8;" }); // BOM → Excel فارسی درست
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// کپیِ جدول به کلیپ‌بورد به‌صورتِ TSV (چسباندنِ مستقیم در Excel/Sheets)
export async function copyTsv(columns, data) {
  const { header, body } = tableToMatrix(columns, data);
  const tsv = [header, ...body].map((row) => row.join("\t")).join("\n");
  try {
    await navigator.clipboard.writeText(tsv);
    return true;
  } catch {
    return false;
  }
}
